import { create } from "zustand";
import axios from "axios";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { message } from "antd";

let OneCustomer = create((set) => ({
  data: {},
  loading: false,
  customerPutting: false,
  error: null,

  fetchData: async (id) => {
    set({ loading: true, error: null });
    try {
      const [user, yt, dk, akt_sverka, akt_sverka_dk, arkhiv] =
        await Promise.all([
          axiosInstance.get("/api/customers/" + id),
          axiosInstance.get("/api/customers/list/" + id),
          axiosInstance.get("/api/dk2/" + id),
          axiosInstance.get("/api/akt_svetka/customer/" + id),
          axiosInstance.get("/api/aktsverka/" + id),
          axiosInstance.get("/api/arkhiv/" + id),
        ]);
      console.log("arkhiv");
      console.log(arkhiv);
      set({
        data: {
          ...user?.data?.data,
          ...yt?.data,
          ...dk?.data,
          akt_sverka: [...akt_sverka?.data?.data],
          akt_sverka_dk: { ...akt_sverka_dk?.data },
          arkhiv: arkhiv?.data?.data,
        },
        loading: false,
      });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  
  fetchNotificationsData: async (id) => {
    try {
      const info = await axiosInstance.get("/api/notifications/" + id);

      console.log("notification");
      console.log(info);
      set((state) => ({
        data: {
          ...state?.data,
          notify: info?.data,
        },
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  archiveYKX: async (id, is_dk) => {
    set({ loading: false, error: null });
    try {
      const { data } = await axiosInstance.post(`/api/chiqim/dk`, {
        nakladnoy_id: [id],
        is_dk: !is_dk,
        dk_comment: "HISSOBLAMASLIK UCHUN ARXIVLADIM!",
      });

      message.success(
        is_dk ? id + "- Yukxati arxivdan chiqdi!" : id + "- Yukxati arxivlandi!"
      );
      console.log(data);
      set((state) => ({
        data: {
          ...state?.data,
          ykx: [
            ...state?.data?.ykx.map((el) => {
              if (el?.id == id) {
                return {
                  ...el,
                  is_dk: !is_dk,
                };
              }
              return el;
            }),
          ],
        },
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  putColorYKX: async (nakladnoy_id, color) => {
    set((state) => ({
      data: {
        ...state?.data,
        ykx: [
          ...state?.data?.ykx.map((el) => {
            if (el?.id == nakladnoy_id) {
              return {
                ...el,
                bgColor: color,
              };
            }

            return el;
          }),
        ],
      },
      loading: false,
      error: null,
    }));
    try {
      const { data } = await axiosInstance.post("/api/chiqim/color", {
        nakladnoy_id: [nakladnoy_id],
        bgColor: color,
      });
      console.log("color");
      console.log(color);
      // set((state) => ({
      //   data: {
      //     ...state?.data,
      //     ykx: [
      //       ...state?.data?.ykx.map((el) => {
      //         if (el?.id == nakladnoy_id) {
      //           return {
      //             ...el,
      //             bgColor: color,
      //           };
      //         }

      //         return el;
      //       }),
      //     ],
      //   },
      //   loading: false,
      // }));
    } catch (error) {
      set((state) => ({
        data: {
          ...state?.data,
          ykx: [
            ...state?.data?.ykx.map((el) => {
              if (el?.id == nakladnoy_id) {
                return {
                  ...el,
                  bgColor: "#FFF",
                };
              }

              return el;
            }),
          ],
        },
        loading: false,
        error: error.message,
      }));
    }
  },
  putColorMYTICKET: async (my_ticket_id, color, id) => {
    let ticket = null;
    set((state) => ({
      data: {
        ...state?.data,
        akt_sverka: [
          ...state?.data?.akt_sverka?.map((el) => {
            if (el?.id == my_ticket_id) {
              ticket = el;
              return {
                ...el,
                bgColor: color,
              };
            }

            return el;
          }),
        ],
      },
      loading: false,
      error: null,
    }));
    try {
      const { data } = await axiosInstance.put(
        "/api/akt_svetka/" + my_ticket_id,
        {
          ...ticket,
          bgColor: color,
        }
      );
      console.log("color");
      console.log(data);
    } catch (error) {
      set((state) => ({
        data: {
          ...state?.data,
          ykx: [
            ...state?.data?.ykx.map((el) => {
              if (el?.id == my_ticket_id) {
                return {
                  ...el,
                  bgColor: "#FFF",
                };
              }

              return el;
            }),
          ],
        },
        loading: false,
        error: error.message,
      }));
    }
  },

  updateUser: async (id, values) => {
    try {
      set((state) => ({
        data: state?.data,
        customerPutting: false,
      }));
      const response = await axiosInstance.put(`/api/customers/${id}`, values);
      set((state) => ({
        data: { ...state.data, ...values },
        customerPutting: true,
      }));
      this.fetchData();
    } catch (error) {
      set({ error: error.message });
    }
  },
  // Search customers from the database
  deleteCustomer: async (id) => {
    set({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.delete(`/api/customers/${id}`);
      set((state) => ({
        data: { ...state?.data, ...data.data },
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  // delete ykx
  deleteYKX: async (id) => {
    set({ loading: false, error: null });
    try {
      const { data } = await axiosInstance.delete(`/api/chiqim/${id}`);
      set((state) => ({
        data: {
          ...state?.data,
          ykx: [
            ...state?.data?.ykx?.filter((el) => Number(el?.id) !== Number(id)),
          ],
        },
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  // acts
  actYKX: async (id) => {
    set({ loading: false, error: null });
    try {
      const { data } = await axiosInstance.get(`/api/customers/list/` + id);
      set((state) => ({
        data: {
          ...state?.data,
          ...data,
        },
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export { OneCustomer };
